import CommonDialog from '../../shared/dialog/CommonDialog';
import css from '../account-settings.module.scss';
import { DeleteDeviceForm } from './DeleteDeviceForm';

interface DeleteDeviceDialogProps {
  shouldShow: boolean;
  handleClose: () => void;
  handleDeleteError: () => void;
  deviceId?: number | null;
}

export default function DeleteDeviceDialog({
  shouldShow,
  handleClose,
  handleDeleteError,
  deviceId,
}: DeleteDeviceDialogProps) {
  return (
    <CommonDialog
      data-testid="deleteDeviceDialog"
      dialogOpen={shouldShow}
      handleDialogClose={handleClose}
      classNames={{
        body: css.dialogBody,
        content: css.dialogContent,
      }}
      closeButtonProps={{ className: css.closeIcon }}
      preventOverlayClose
    >
      <DeleteDeviceForm
        deviceId={deviceId}
        closeCallback={handleClose}
        handleDeleteError={handleDeleteError}
      />
    </CommonDialog>
  );
}
